import Layout from '@/components/layout/Layout';

const PogojiPoslovanja = () => {
  return (
    <Layout
      title="Pogoji poslovanja | Lux Decor by Kamen"
      description="Splošni pogoji poslovanja podjetja Lux Decor by Kamen za nakup in uporabo naše luksuzne kopalniške opreme."
    >
      <section className="py-16 bg-luxbeige">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-semibold mb-6">Pogoji poslovanja</h1>
            <div className="h-1 w-24 bg-luxgold mb-10"></div>
            
            <div className="lux-card space-y-6">
              <section>
                <h2 className="text-2xl font-medium mb-4">1. Splošne določbe</h2>
                <p className="text-luxgray">
                  Splošni pogoji poslovanja določajo pravice in obveznosti uporabnika in ponudnika pri sklepanju pogodb
                  o prodaji blaga preko spletne strani www.luxdecor.si ter urejajo poslovna razmerja med podjetjem KAMEN d.o.o. in kupci izdelkov iz ponudbe podjetja.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">2. Cene</h2>
                <p className="text-luxgray">
                  Vse cene izdelkov so navedene v evrih (EUR) in vsebujejo DDV. Cene ne vsebujejo stroškov dostave, ki so navedeni posebej. 
                  KAMEN d.o.o. si pridržuje pravico do spremembe cen, pogojev prodaje in drugih pogojev brez predhodnega obvestila.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">3. Naročila in dobava</h2>
                <p className="text-luxgray">
                  Naročila sprejemamo preko e-pošte, telefona ali osebno v našem salonu. Po prejemu naročila vam bomo poslali potrditev naročila z vsemi potrebnimi podatki.
                  Dobavni rok je odvisen od razpoložljivosti izdelkov in je naveden na potrdilu naročila. Standardni dobavni rok za izdelke na zalogi je 3-5 delovnih dni.
                  Za izdelke po naročilu je dobavni rok od 4 do 8 tednov.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">4. Plačilni pogoji</h2>
                <p className="text-luxgray">
                  Plačilo je možno na naslednje načine:
                </p>
                <ul className="list-disc pl-6 mt-2 text-luxgray">
                  <li>Predračun (nakazilo na transakcijski račun)</li>
                  <li>Plačilo ob prevzemu (gotovina)</li>
                  <li>Plačilo s kreditno kartico v salonu</li>
                </ul>
                <p className="text-luxgray mt-2">
                  Za naročila po meri zahtevamo predplačilo v višini 50% vrednosti naročila.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">5. Pravica do odstopa od pogodbe</h2>
                <p className="text-luxgray">
                  Kupec ima pravico, da v 14 dneh od prevzema blaga podjetju sporoči, da odstopa od pogodbe, ne da bi mu bilo potrebno navesti razlog za svojo odločitev.
                  Rok se začne šteti en dan po datumu prevzema blaga. Edini strošek, ki bremeni potrošnika v zvezi z odstopom od pogodbe, je strošek vračila blaga.
                </p>
                <p className="text-luxgray mt-2">
                  Blago je potrebno vrniti prodajalcu najkasneje v roku 14 dni od oddanega sporočila o odstopu od pogodbe. Blago mora biti nepoškodovano, 
                  v originalni embalaži in v nespremenjeni količini.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">6. Garancija in reklamacije</h2>
                <p className="text-luxgray">
                  Za vse izdelke velja zakonsko predpisana garancija. Za nekatere izdelke nudimo tudi podaljšano garancijo, ki je navedena pri posameznem izdelku.
                  V primeru reklamacije nas kontaktirajte preko e-pošte info@luxdecor.si ali telefona +386 31 467 272.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">7. Končne določbe</h2>
                <p className="text-luxgray">
                  Splošni pogoji poslovanja so objavljeni na spletni strani www.luxdecor.si in veljajo od 1.1.2023 dalje.
                  Pridržujemo si pravico do spremembe splošnih pogojev poslovanja brez predhodnega obvestila.
                </p>
                <p className="text-luxgray mt-2">
                  Za vse spore, ki izhajajo iz teh splošnih pogojev poslovanja, je pristojno sodišče v Mariboru.
                </p>
              </section>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PogojiPoslovanja;